import React, { useState, useEffect } from "react"
import { Alert } from "@material-ui/lab"

const AlertWithTimer = ({ time = 3000, onHide = () => {}, children, ...restProps }) => {
    const [openStatus, setOpenStatus] = useState(true)
    useEffect(() => {
        const timer = setTimeout(() => {
            setOpenStatus(false)
            onHide()
        }, time)
        return () => {
            clearTimeout(timer)
        }
    }, [openStatus])

    return <>{openStatus ? <Alert {...restProps}>{children}</Alert> : null}</>
}

export default AlertWithTimer
